import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CommonTokenService,
  TokenResponse,
  BaseLoginRequest
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CommonTokenApiService {
  constructor(private apiService: CommonTokenService) {}

  public getCabinetToken(body: BaseLoginRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<TokenResponse> {
    return this.apiService.cabinetTokenGet(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
